"use client";
import { Box, CircularProgress, CircularProgressProps } from "@mui/material";

export const Spinner = (props: CircularProgressProps) => (
  <Box
    style={{
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress {...props} />
  </Box>
);
